module.exports = __webpack_public_path__ + "img/258118f.png";